import script from "./WhyMembers.vue?vue&type=script&setup=true&lang=js"
export * from "./WhyMembers.vue?vue&type=script&setup=true&lang=js"

import "./WhyMembers.vue?vue&type=style&index=0&id=13e0c918&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13e0c918"]])

export default __exports__